import mixpanel, { Dict } from "mixpanel-browser";

const isProd =
  process.env.REACT_APP_ENV === "production" ||
  process.env.REACT_APP_ENV === "prod";
const targetToken = isProd
  ? "70f7c0a833f7d755660c4994f544ca23"
  : "9b84446e6f0696b3892bded027a0a787";
mixpanel.init(targetToken);

export const Mixpanel = {
  identify: (id: string) => {
    mixpanel.identify(id);
  },
  track: (event: string, properties?: Dict) => {
    mixpanel.track(event, properties);
  }
};
